import {
  TemplatesCreate,
  TemplatesUpdate,
  TemplateTranslations,
} from 'lib-shared-legacy-types';

import { ajaxSend } from '../../../api/api';

import {
  TemplatesGetItemsResponse,
  TemplatesQueryParams,
  TemplatesResponse,
} from './types';

const v2BasePath = '/v2/templating/templates';
const v2TranslationsPath = '/v2/templating/templatetranslations';
const v3BasePath = '/v3/templates';

export function getTemplates(
  params: TemplatesQueryParams = {},
): Promise<TemplatesGetItemsResponse> {
  return ajaxSend({
    path: v3BasePath,
    params,
  });
}

export function createTemplate(
  template: TemplatesCreate,
): Promise<TemplatesResponse> {
  const { name, content, subject, type } = template;

  return ajaxSend({
    method: 'POST',
    path: `${v2BasePath}`,
    data: {
      name: name,
      content: content,
      subject: subject,
      type: type,
    },
  });
}

export function updateTemplate(
  templateId: string,
  payload: TemplatesUpdate,
): Promise<TemplatesResponse> {
  const { updates, deletes } = payload;
  const patch = {
    updates: updates,
    deletes: deletes,
  };
  return ajaxSend({
    path: `${v2BasePath}/${encodeURIComponent(templateId)}`,
    method: 'PATCH',
    data: patch,
  });
}

export async function readTemplateById(
  templateId: string,
): Promise<TemplatesResponse | undefined> {
  try {
    return await ajaxSend({
      path: `${v2BasePath}/${encodeURIComponent(templateId)}`,
      method: 'GET',
    });
  } catch (error) {
    return Promise.resolve(undefined);
  }
}

export function removeTemplate(templateId: string): Promise<TemplatesResponse> {
  return ajaxSend({
    path: `${v2BasePath}/${encodeURIComponent(templateId)}`,
    method: 'DELETE',
  });
}

export function updateTemplateTranslations(
  templateId: string,
  translations: TemplateTranslations,
): Promise<TemplatesResponse> {
  return ajaxSend({
    path: `${v2TranslationsPath}/${encodeURIComponent(templateId)}`,
    method: 'PATCH',
    data: { translations },
  });
}

export function removeTemplateTranslations(
  templateId: string,
  localesToDelete: string[],
): Promise<TemplatesResponse> {
  return ajaxSend({
    path: `${v2TranslationsPath}/${encodeURIComponent(templateId)}`,
    method: 'DELETE',
    data: {
      localesToDelete,
    },
  });
}
